<div *ngIf="contextData.context$ | async as context" class="eb-contact-form-login-hint">
  <span *ngIf="linkComponent$ | async as linkComponent">
    {{ 'contact.login.hint.pre' | cxTranslate }}
    <cx-generic-link
      [url]="linkComponent.url + relayState"
      [style]="linkComponent.styleAttributes"
      [class]="linkComponent.styleClasses"
    >
      {{ linkComponent.linkName }}
    </cx-generic-link>
    {{ 'contact.login.hint.post' | cxTranslate }}
  </span>
</div>
